<template>
<div class="login">
  <div class="form">
    <div class="header">
      <b>{{$t('login.password_reset.heading')}}</b>
    </div>
    <div class="body">
      <p class="helper">{{$t('login.password_reset.info')}}</p>
      <div class="form-item">
        <label for="email">{{$t('login.email')}}</label><br>
        <input type="text" name="email" class="text-input" v-model="form.email">
      </div>
      <div class="form-item">
        <button class="btn btn-block" @click="resetRequest">{{ $t('login.password_reset.heading') }}
                </button>
      </div>
    </div>
    <div class="footer">
      <router-link :to="{ name: 'Login'}" tag="a">
        <i class="fa fa-arrow-left fa-fw" aria-hidden="true"></i>{{ $t('login.back')}}
      </router-link>
    </div>
  </div>
</div>
</template>

<script>
import api from '../api'

export default {
  data () {
    return {
      form: {
        email: '',
        reset_url: window.location.origin + '/#/password/reset'
      }
    }
  },
  mounted () {
    this.$Progress.finish()
  },
  methods: {
    resetRequest () {
      var self = this
      self.$Progress.set(25)

      api.postResetRequest(self.form)
      .then(
        () => {
          self.$Progress.finish()
          self.$router.push({path: '/password/sent', query: {email: self.form.email}})
        }
      ).catch(
        () => {
          alert('Something went wrong')
          self.$Progress.finish()
        }
      )
    }
  }
}
</script>

<style scoped lang="stylus" src="../styles/_Login.styl"/>



// WEBPACK FOOTER //
// src/components/PassReset.vue